
export const environment = {
  apiBaseUri: 'https://artsway-portal-api-staging.azurewebsites.net/api/',
  apiDevUri: 'https://artsway-portal-api-staging.azurewebsites.net/api/',
  production: false
};
